import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { ButtonProps, Dialog } from '@optimus-web/core';
import { closeGuestsDialog } from '../../../../../actions';
import { isGuestsDialogOpen } from '../../../../../selectors';
import SpacesTable from './NightsTable';
import { SpaceTableOwnProps } from './types';

interface StateProps {
    active: boolean;
}

interface DispatchProps {
    close(): void;
}

type GuestsDialogProps = StateProps & SpaceTableOwnProps & DispatchProps & { serviceId: string };

const GuestsDialog = ({ active, billingScreen, editInternals, editProfile, close, serviceId }: GuestsDialogProps) => {
    const actions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.Close} />,
            onClick: close,
            variant: 'ghost',
            type: 'submit',
        },
    ];

    const actionWithClose = (action: (customerId: string) => void) => (customerId: string) => {
        close();
        action(customerId);
    };

    const billingScreenAction = actionWithClose(billingScreen);
    const editInternalsAction = actionWithClose(editInternals);
    const editProfileAction = actionWithClose(editProfile);

    return (
        <Dialog
            active={active}
            actions={actions}
            onClose={close}
            title={<LocalizedText textKey={TextKey.GuestPlural} />}
        >
            <SpacesTable
                billingScreen={billingScreenAction}
                editInternals={editInternalsAction}
                editProfile={editProfileAction}
                serviceId={serviceId}
            />
        </Dialog>
    );
};

export default withScopeContext(
    connect<StateProps, DispatchProps, SpaceTableOwnProps, ApplicationState>(
        createStructuredSelector({
            active: isGuestsDialogOpen,
        }),
        (dispatch: CommanderThunkDispatch, { scope }) => ({
            close: () => dispatch(closeGuestsDialog({ scope })),
        })
    )(GuestsDialog)
);
